/**
 * share.adapter — แชร์กิจกรรมเข้าแชท LINE (`SharePort` ของ `feature-activities`)
 *
 * 🔑 **ทำไมอยู่ `member/adapters/` ไม่ใช่ `shared/web/`** — มันคือ **LINE** ไม่ใช่
 *    "การแชร์" แบบทั่วไป · `activities-admin--web` (Day 7) ไม่มีทางใช้ ⇒ ยกขึ้น
 *    `shared/` เมื่อไรก็ลาก `@line/liff` ขึ้นไปด้วยทั้งที่มีผู้ใช้รายเดียว
 *    (เกณฑ์ของ `shared/` คือ **"เว็บกี่ตัวใช้"** — `frontend-structure §2`)
 *    ⇒ วันที่มีช่องทางแชร์ที่ทุกเว็บใช้จริง (Web Share API) **ตัวนั้น**ค่อยขึ้น `shared/`
 *
 * ⛔ **ตัวนี้ยังพิสูจน์ของจริงไม่ได้จนกว่าจะทดสอบในแอป LINE**
 *    `liff.isInClient()` คืน `false` เสมอนอกแอป LINE ⇒ ปุ่มแชร์จะไม่โผล่ให้ใครกด
 *    ซึ่งเป็นพฤติกรรมที่ถูกต้อง **แต่ไม่ใช่หลักฐานว่าการแชร์ทำงาน**
 */
import liff from '@line/liff';
import type { SharePort } from '@theelite/frontend-member-feature-activities';

export function createShareAdapter(): SharePort {
  return {
    canShare() {
      /**
       * `isApiAvailable('shareTargetPicker')` ไม่พอ — มันคืน `true` ได้ทั้งที่อยู่
       * นอกแอป LINE (ตัว API ถูกประกาศไว้แต่เรียกแล้วล้ม) ⇒ เช็ค `isInClient()` ด้วย
       */
      try {
        return liff.isInClient() && liff.isApiAvailable('shareTargetPicker');
      } catch {
        // `liff.init()` ยังไม่เสร็จ ⇒ ยังไม่รู้ ⇒ ถือว่าแชร์ไม่ได้ (ไม่โชว์ปุ่ม)
        return false;
      }
    },

    async share(input) {
      const result = await liff.shareTargetPicker([
        {
          type: 'text',
          /**
           * 📌 **ยังเป็นข้อความธรรมดา ไม่ใช่ Flex Message การ์ดสวย**
           *    DoD ข้อ "แชร์เข้าแชท LINE เป็นการ์ดสวย" ต้องใช้ Flex ซึ่งออกแบบ + ทดสอบ
           *    ในแอป LINE จริงเท่านั้น ⇒ **ทำตอนที่ทดสอบในแอปจริงได้ อย่ารายงานว่าปิด**
           */
          text: `${input.title}\n${input.url}`,
        },
      ]);

      /**
       * SDK คืน `undefined` เมื่อผู้ใช้ **ปิดหน้าต่างเลือกเพื่อนโดยไม่เลือกใคร**
       * ⇒ ทางเดินปกติ ไม่ใช่ error (หน้าเว็บจะเงียบ ๆ ไม่ขึ้นข้อความ)
       */
      return { ok: true, sent: result !== undefined };
    },
  };
}
